import { GrailedAPIHeavyListing } from "storefront/Listing/GrailedAPIHeavyListing";
import { GrailedAPILightListing } from "storefront/Listing/GrailedAPILightListing";
import { AlgoliaListing } from "storefront/Listing/AlgoliaListing";
import { AlgoliaInstantSearchListing } from "storefront/components/FiltersInstantSearch/CustomInfiniteHits/NonEmpty";
import { Product } from "./Event";
import soldPriceWithShipping from "./soldPriceWithShipping";

/**
 * @name Analytics.getProductProperties
 * @description Returns a formatted object for a product-related event
 */
const getProductProperties = (
  listing:
    | GrailedAPIHeavyListing
    | GrailedAPILightListing
    | AlgoliaInstantSearchListing
    | AlgoliaListing,
  index?: number,
): Product => ({
  badges: listing.badges,
  brand: listing.designerNames,
  category: listing.categoryPath,
  department: listing.department,
  ...(index !== undefined && { feedPosition: index }),
  name: listing.title,
  // eslint-disable camelcase
  listing_id: listing.id,
  product_id: listing.id,
  // eslint-enable camelcase
  size: listing.category
    ? `${listing.category}.${listing.size}`
    : `${listing.categoryPath.split(".")[0]}.${listing.size}`,
  sold: listing.sold,
  strata: listing.strata,
  styles: listing.styles,
  value: listing.sold ? soldPriceWithShipping(listing) : listing.price,
});

export default getProductProperties;
